/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MoveIcon = /*#__PURE__*/ createSvgIcon(
  'MoveIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.255 9.98l-2.13-2.137.71-.706 2.83 2.842-2.83 2.853-.71-.704 2.13-2.147z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.96 10.48H2v-1h15.96v1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 9.48h15.96v1H2v-1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.707 9.98l2.137-2.136-.707-.707-2.843 2.842 2.842 2.854.708-.706-2.138-2.146zM9.98 1.294l2.853 2.842-.706.708-2.146-2.138-2.137 2.138-.707-.707 2.842-2.843z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.48 2v15.96h-1V2h1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.48 17.96V2h1v15.96h-1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.98 17.255l2.148-2.13.704.71-2.853 2.83-2.842-2.83.706-.71 2.138 2.13z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MoveIcon;
